import { useCallback } from 'react';

import { IconPromotion as IconPromotionInterface } from '@interfaces';
import { useTheme } from '@utilities';

export interface IconPromotionProps extends IconPromotionInterface {}

function useIconPromotion({ columns, blockTheme }: Partial<IconPromotionProps>) {
  const theme = useTheme({ blockTheme });

  const getGridColumns = useCallback((): string => {
    if (columns === 2) return 'md:grid-cols-2';
    if (columns === 3) return 'lg:grid-cols-3';
    if (columns === 4) return 'xl:grid-cols-2 2xl:grid-cols-4';
    return '';
  }, [columns]);

  const gridColumns = getGridColumns();

  return {
    theme,
    gridColumns,
  };
}

export default useIconPromotion;
